import { createAction, props } from '@ngrx/store';
import { PersonalInformation } from './../../interfaces';

enum PersonalInformationActions {
    loadPersonalInformation = '[Personal Information] Load Personal Information',
    setPersonalInformation = '[Personal Information] Set Personal Information Success',
    resetPersonalInformation = '[Personal Information] Reset Personal Information Failure'
}

export const LoadPersonalInfoAction = createAction(
    PersonalInformationActions.loadPersonalInformation
);

export const ResetPersonalInfoAction = createAction(
    PersonalInformationActions.resetPersonalInformation
);

export const SetPersonalInfoAction = createAction(
    PersonalInformationActions.setPersonalInformation,
    props<PersonalInformation>()
);